import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { WatchOptions } from 'vue';
import InputText from '@/components/inputs/InputText/InputText.vue';
import InputNumber from '@/components/inputs/InputNumber/InputNumber.vue';
import InputCheckbox from '@/components/inputs/InputCheckbox/InputCheckbox.vue';
import InputRadioButton from '@/components/inputs/InputRadioButton/InputRadioButton.vue';
import { AnswerChoices, BreastOperation } from '@/models/VariousEnum';
import { BreastOperations } from '@/models/QuestQuestion';

@Component({
  components: {
    InputText,
    InputNumber,
    InputCheckbox,
    InputRadioButton,
  },
})
export default class BreastOperationsPart extends Vue {
  @Prop()
  public value!: BreastOperations;
  @Prop({ default: false })
  public readonly!: boolean;
  @Prop({ default: true })
  public required!: boolean;

  public answerChoices: any = AnswerChoices;
  public breastOperation: any = BreastOperation;
  public updating?: boolean = false;
  public errorMessage: string = '';
  public error: boolean = false;

  /**
   * Get an array of all the property names from the value prop in lowercase
   */
  get instanceFields(): string[] {
    if (this.value) {
      const fields: string[] = [];
      Object.keys(this.value).forEach(e => fields.push(e.toLowerCase()));
      return fields;
    }
    return [];
  }

  /**
   * Get the errors returned by the API corresponding to the model properties
   */
  get errors(): string[] {
    if (this.$store.state.questionnaireValidationErrors) {
      const obj = this.$store.state.questionnaireValidationErrors;
      const errorFields: string[] = [];
      Object.keys(obj).forEach((e) => {
        if (this.instanceFields.includes(e.toLowerCase())) {
          errorFields.push(obj[e].errors);
        }
      });
      return errorFields;
    }

    return [];
  }

  get showMoreQuestions(): boolean {
    return this.value.flagBreastSurgery === this.answerChoices.Yes;
  }

  get subQuestionRequired(): boolean {
    return this.value.flagBreastSurgery === this.answerChoices.Yes;
  }

  protected mounted() {
  }

  protected onBreastOperationChange(value: boolean, operation: BreastOperation) {
    // TODO: compute the code based on checked boxes and emit the value to the parent
    switch (operation) {
      case BreastOperation.BenignAffection:
        break;
      case BreastOperation.Cancer:
        break;
      case BreastOperation.PlasticSurgery:
        break;
      case BreastOperation.Other:
      break;
      default:
        break;
    }
  }

  @Watch('value', { deep: true } as WatchOptions)
  protected onValueChanged(value: BreastOperations, oldValue: BreastOperations) {
    if (value) {
      this.$emit('input', value);
    }
  }
}
